var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 117,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2A4A4",
    d: "M12.014 24.743c24.727-30.58 83.268-32.29 100.483-8.035 9.485 13.365 5.522 33.342 3.566 43.2-3.599 18.14-12.473 29.817-14.41 32.293-4.702 6.01-16.123 20.611-33.308 23.948C38.986 121.85 2.351 92.818.321 60.062c-1.17-18.884 9.555-32.675 11.693-35.319"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M70.36 11.16 17.055 8.078c-1.227-.06-2.332 1.28-2.332 2.405v68.64c0 1.56 1.593 1.874 2.82 1.749l52.817-5.395c.965-.098 1.744-.98 1.744-1.972V13.04c0-.99-.779-1.832-1.744-1.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m71.236 10.615-53.41-2.63c-1.228-.06-2.228.81-2.228 1.944v69.178c0 1.134 1.001 1.95 2.227 1.824l53.41-5.498c.965-.099 1.744-.989 1.744-1.987V12.51c0-1-.779-1.847-1.743-1.895"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M17.825 79.992c-.662.067-1.202-.375-1.202-.986V9.976c0-.612.54-1.083 1.202-1.052l53.41 2.525c.522.024.945.484.945 1.024v61.051c0 .54-.423 1.023-.944 1.076z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.793 72.963-45.682 4.401V13.68l45.682 1.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "m49.523 15.712-18.257.228.41-4.118c.03-.534.417-.974.926-1.052l3.093-.475a1.11 1.11 0 0 0 .835-.642l.334-.728 8.087.5z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M59.271 13.04a.98.98 0 0 0-.93-.814l-2.917-.13c-1.324-.06-2.296-1.136-2.246-2.498l.112-3.158c.021-.584-.396-1.052-.969-1.085l-.96-.057c-.73-.042-1.217-.688-1.115-1.433.18-1.302-.713-2.426-2.006-2.514-1.302-.089-2.519.907-2.713 2.225-.028.2-.097.391-.203.563-.3.483-.828.75-1.345.718l-.989-.06a1.31 1.31 0 0 0-1.32.977l-.822 3.205c-.355 1.386-1.696 2.388-3.12 2.324l-3.2-.144a1.39 1.39 0 0 0-1.28.761l-1.929 3.827c-.158.313.037.652.381.663l27.752.922a.515.515 0 0 0 .505-.594zM47.848 4.083a.635.635 0 0 1-.591-.743.77.77 0 0 1 .793-.654.635.635 0 0 1 .59.743.77.77 0 0 1-.792.654"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "M59.435 13.126a.98.98 0 0 0-.93-.814l-2.917-.13c-1.325-.06-2.296-1.136-2.247-2.499l.113-3.157c.021-.584-.396-1.052-.97-1.085l-.96-.057c-.73-.042-1.217-.688-1.114-1.433.18-1.302-.713-2.426-2.006-2.514-1.303-.089-2.519.907-2.713 2.225a1.5 1.5 0 0 1-1.548 1.28l-.987-.058a1.31 1.31 0 0 0-1.32.976l-.823 3.205c-.355 1.386-1.696 2.388-3.12 2.324l-3.201-.144a1.39 1.39 0 0 0-1.28.76l-1.929 3.827c-.157.313.037.652.381.663l27.752.922a.515.515 0 0 0 .505-.594zM48.012 4.169a.635.635 0 0 1-.592-.743.77.77 0 0 1 .793-.654.635.635 0 0 1 .59.743.77.77 0 0 1-.79.654"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.685 14.884c-2.476-1.529-4.376-.445-5.919-2.17-1.651-1.846-.537-4.275-2.246-5.421-1.094-.734-2.07-.087-3.342-.285-.466-.073-.964-.258-1.48-.62l-.686 2.672c-.355 1.386-1.697 2.387-3.12 2.324l-3.2-.14a1.39 1.39 0 0 0-1.28.761l-1.929 3.827c-.157.313.037.652.381.663l25.22.838c-.634-1.01-1.423-1.848-2.4-2.45",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m63.339 34.253-35.38.19v-2.101l35.38-.113zM57.356 40.089l-29.926.72v-2.187l29.926-.584zM57.356 43.68l-29.926.96v-2.188l29.926-.824zM57.356 47.27l-29.926 1.2v-2.188l29.926-1.063zM57.356 50.86 27.43 52.3v-2.188l29.926-1.302zM63.337 39.944l-3.937.095v-2.042l3.937-.077zM63.337 43.487l-3.937.126v-2.041l3.937-.109zM63.337 47.03l-3.937.158v-2.042l3.937-.14zM63.337 50.573l-3.937.189V48.72l3.937-.171zM57.356 56.688 27.43 58.516v-2.188l29.926-1.691zM57.356 60.279 27.43 62.346v-2.188l29.926-1.93zM57.356 63.87 27.43 66.176v-2.188l29.926-2.17zM57.356 67.46 27.43 70.007V67.82l29.926-2.41zM63.337 56.323l-3.937.24v-2.042l3.937-.222zM63.337 59.865l-3.937.272v-2.041l3.937-.254zM63.337 63.409l-3.937.303V61.67l3.937-.285zM63.337 66.952l-3.937.335v-2.042l3.937-.317zM27.959 28.664v2.1l13.27-.02v-2.072zM27.959 21.308v2.1l13.27.081v-2.072zM27.959 24.986v2.1l13.27.03v-2.071z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M7.464 97.745h1.873l2.32-5.897s-4.257.298-4.193 5.897"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m51.185 107.944-12.192-2.261s-1.107-9.411 4.343-10.305 8.375 6.397 7.85 12.566"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M50.585 96.872h.004c.38.038.73.187 1.077.4.333.17.735.369.735.623v.006c1.285 1.336 2.129 3.804 2.135 6.568.006 3.681-1.491 6.656-3.465 7l.005.002c-.133.019-1.788.618-7.004.028-.139-2.24-.22-14.923-.22-14.923s4.166-.216 6.733.296"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M40.172 103.763c0 4.21 1.95 7.699 4.311 7.787 2.317.086 4.16-3.144 4.155-7.21s-1.85-7.533-4.163-7.763c-2.358-.233-4.303 2.98-4.303 7.186"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.022 103.859c0 2.988 1.3 5.471 2.882 5.545 1.563.072 2.812-2.237 2.81-5.156-.003-2.918-1.256-5.39-2.816-5.532-1.581-.143-2.877 2.158-2.876 5.143"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M16.244 92.39h.003c.34.042.667.16.956.344.27.146.198.317.68.537v.005c.803 1.15 1.645 3.276 1.649 5.657.005 3.172-1.252 5.733-2.853 6.029h-.018c-.108.017-1.46.533-5.692.025-.112-1.93-.184-12.856-.184-12.856s3.376-.18 5.46.258"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M7.795 98.325c0 3.626 1.581 6.632 3.498 6.708 1.878.074 3.374-2.708 3.37-6.21-.004-3.503-1.503-6.49-3.377-6.688-1.913-.2-3.491 2.567-3.491 6.19"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.295 98.408c0 2.573 1.054 4.712 2.337 4.775 1.268.063 2.282-1.927 2.28-4.44s-1.019-4.644-2.285-4.765c-1.281-.123-2.333 1.858-2.332 4.43"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M96.686 93.912h.005c.472 0 .833.238 1.266.45.417.16.687.481.847.756v.007c1.766 1.432 2.773 4.302 2.773 7.607 0 4.398-1.874 8.022-4.351 8.519l.024.003c-.167.029-2.198.802-8.446.34-.161-2.551-.245-17.146-.245-17.146s4.978-.858 8.127-.536"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M89.297 111.634c2.752 0 4.982-3.841 4.982-8.578 0-4.738-2.23-8.579-4.982-8.579s-4.983 3.84-4.983 8.579c0 4.737 2.231 8.578 4.983 8.578"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M89.793 109.156c1.857 0 3.362-2.746 3.362-6.134s-1.505-6.134-3.362-6.134c-1.856 0-3.361 2.746-3.361 6.134s1.505 6.134 3.361 6.134"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M5.851 94.442a2.47 2.47 0 0 0 .597 2.207l1.014 1.099c.278-3.241 1.955-5.734 3.984-5.734 2.22 0 4.024 2.993 4.024 6.683a10.5 10.5 0 0 1-.287 2.475l.444.183 23.964 4.439c-.065-.494-.185-1.006-.185-1.526 0-.47-.007-.928-.007-1.377v-.005c.803-3.82 2.757-6.73 5.442-6.73 3.002 0 5.479 3.634 5.479 8.114 0 1.224-.162 2.383-.487 3.423l3.584.662a.5.5 0 0 0 .023.084c.112.121.978.885 5.213.885h46.734c2.115 0 3.693-1.845 3.693-3.96v-.174c0-.81-.39-1.549-1.115-1.913 0 0 1.294-3.708.268-8.144-.411-1.771-1.166-3.658-2.529-5.47a16.3 16.3 0 0 0-3.002-3.043s-5.318-4.412-15.076-5.559c0 0-8.089-5.88-15.49-9.777a25.1 25.1 0 0 0-11.774-2.902H33.308a25.3 25.3 0 0 0-13.298 3.78l-7.047 4.353s-1.682 1.002-3.397 3.404C7.614 82.65 5.62 87.19 6.014 94.11l-.167.332z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M53.427 108.354a.4.4 0 0 0 .017.083c.326.204.736 1.207 11.577.885h40.367c2.115 0 3.693-1.844 3.693-3.959v-.174c0-.047.066-.092.063-.139-.048-.755-.459-1.432-1.143-1.775l-47 .446s-4.433-.807-5.954-.012c-.212.112-.365.254-.442.435-.639 1.473-1.474 3.522-1.178 4.21"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.389 95.229v.611a1.74 1.74 0 0 0 1.818 1.742l5.027-.213a4.82 4.82 0 0 0 3.206-1.407l.828-.828a14.5 14.5 0 0 0-2.546-5.47q-.027.002-.053.005l-2.414 1.906a9.5 9.5 0 0 1-4.4 1.93 1.744 1.744 0 0 0-1.466 1.724"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M75.076 94.527c.33.397.882.721 1.224.722l18.82-.003c.34 0 .824-.324 1.072-.72.246-.394.133-.71-.25-.71h-20.76c-.383 0-.438.318-.106.712z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M77.198 97.098c.349.417.856.758 1.135.757l15.296-.005c.278 0 .716-.34.977-.757.26-.414.205-.747-.116-.746l-17.33.003c-.322 0-.308.334.038.748",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.609 97.71c1.145-.03 2.06-.86 2.06-1.874v-.619c0-.965-.83-1.772-1.914-1.867l-2.045-.178-12.165-3.203.266 1.533c.403 2.317 2.173 4.267 4.642 5.114l1.807.62c1.201.409 2.466.601 3.734.567z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m55.055 103.758 5.074 1.392h49.082c-.048-.803-.494-1.48-1.177-1.823l-47.018.443s-4.441-.807-5.961-.012",
    opacity: 0.4,
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M23.093 100.333h.009c.163-.321.292-.221.286-.385-.003-.098-.292-9.975 0-13.982.25-3.469.835-4.098.885-4.145a.31.31 0 0 0 .13-.378.3.3 0 0 0-.384-.17c-.214.083-.934.668-1.22 4.612-.293 4.035-.004 13.983 0 14.082.003.161.134.366.294.366",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m5.849 94.442.164-.331c-.393-6.923 1.599-11.462 3.55-14.192 1.23.071 2.877.683 2.755 3.475-.195 4.409.686 6.686 4.037 8.703 1.59.955 3.335 1.777 4.746 2.998 1.26 1.094 1.847 2.774 3.13 3.803 2.17 1.739 5.115.967 7.644.852 2.303-.107 7.524-.216 7.524 3.134v.006c0 .449.007.908.007 1.377 0 .52.125 1.032.19 1.526l-23.968-4.438-.445-.183c.193-.811.29-1.642.286-2.475 0-3.69-1.804-6.683-4.024-6.683-2.03 0-3.706 2.493-3.984 5.734l-1.015-1.1a2.47 2.47 0 0 1-.597-2.206",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M38.248 70.47s3.155 8.073 3.942 9.256c.074.11.167.273.28.367 1.092.911 3.762 1.133 3.762 1.133h39.33C76.786 74.484 69.297 70.47 69.297 70.47z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M14.074 77.255s4.196 1.715 9.833 3.33a19.6 19.6 0 0 1 .955-3.162c.876-2.22 2.36-4.82 4.879-7.111-2.262.16-4.494.618-6.637 1.36-2.957 1.03-6.095 2.753-9.03 5.583"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M25.348 80.987c2.809.76 5.896 1.463 8.96 1.913a46 46 0 0 0 5.15.476q.735.022 1.45.015l-.003-.006c-.074-.314-3.064-12.568-5.837-12.931a26 26 0 0 0-2.919-.209c-2.996 2.215-4.729 4.967-5.722 7.322a19 19 0 0 0-1.08 3.42"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M42.469 80.09c1.09.91 3.761 1.136 3.761 1.136h39.33C76.784 74.484 69.295 70.47 69.295 70.47h-.556c-.87.321-1.722 1.095-2.476 2.168-3.043 4.338-19.853 1.05-23.795 7.453",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M39.459 83.377q.733.022 1.45.014l-.004-.006z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M26.429 77.565a19 19 0 0 0-1.08 3.423c2.81.76 5.897 1.464 8.96 1.913a6.5 6.5 0 0 1-1.18-1.647c-1.524-2.943-4.211-3.449-6.7-3.689",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M14.074 77.255s4.196 1.716 9.833 3.33c.228-1.078.548-2.136.955-3.161-1.503-.15-2.8-.384-3.543-1.277-1.301-1.573.313-3.336 1.783-4.474-2.955 1.029-6.093 2.752-9.028 5.582",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M41.015 83.967s-1.245-4.914-3.014-5.11-6.814-1.638-7.272.786.459 3.631 3.014 3.782 4.257 0 4.257 0l1.18 1.263s1.9 1.31 1.835-.721"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.605 83.967s-1.245-4.914-3.014-5.11-6.814-1.638-7.273.786.46 3.631 3.014 3.782 4.257 0 4.257 0l1.18 1.263s1.901 1.31 1.836-.721"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "M73.895 35.979c-5.038 3.55-11.927 2.197-15.357-3.017s-2.122-12.343 2.915-15.895c5.038-3.553 11.927-2.197 15.357 3.017s2.122 12.347-2.915 15.895M62.193 18.19c-4.44 3.13-5.593 9.412-2.57 14.007 3.025 4.595 9.094 5.788 13.533 2.66 4.438-3.13 5.593-9.413 2.568-14.008s-9.093-5.787-13.532-2.659"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M72.517 31.372c-1.719 9.277 8.458 19.096 19.311 21.25 10.853 2.156 18.273-4.17 19.993-13.447s-2.916-17.995-13.768-20.15-23.817 3.07-25.536 12.347m8.984-2.504-1.532 8.269c-.345 1.861-2.829 2.069-3.472.294-.663-1.828-.85-3.646-.53-5.375s1.144-3.347 2.413-4.791c1.233-1.402 3.466-.258 3.12 1.604z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M111.284 39.068c-.837 4.522-3.091 8.306-6.344 10.653-3.506 2.527-8.001 3.339-13.005 2.344-5.235-1.039-10.368-3.881-14.083-7.794-3.866-4.073-5.568-8.616-4.794-12.793.773-4.177 3.979-7.746 9.026-10.049 4.85-2.212 10.635-2.887 15.87-1.848 5.004.993 8.89 3.47 11.244 7.16 2.182 3.428 2.921 7.806 2.086 12.327M75.431 31.95c-.338 1.823-.151 3.734.555 5.68.383 1.057 1.33 1.677 2.413 1.582s1.904-.867 2.108-1.968l1.532-8.269c.204-1.1-.288-2.135-1.255-2.636-.967-.5-2.074-.29-2.807.543-1.353 1.542-2.21 3.245-2.546 5.068"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M95.745 47.798c6.303 0 11.413-5.29 11.413-11.814s-5.11-11.814-11.413-11.814-11.413 5.29-11.413 11.814c0 6.525 5.11 11.814 11.413 11.814",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "m89.58 51.474-5.517 3.89 14.141 21.495c.297.45.682.835 1.132 1.133l1.078.72c.702.47 1.849.324 2.813-.356s1.515-1.73 1.351-2.579l-.251-1.302a4.2 4.2 0 0 0-.603-1.505z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "M92.095 61.35c.758 1.86 3.386 1.084 4.5 3.42.745 1.564-.168 2.477.902 3.787 1.002 1.227 2.04.722 2.772 2 .681 1.19 0 2.004.74 3.34.537.966 1.284 1.235 1.896 1.675.487.35.977.872 1.346 1.687.289-.491.414-1.015.324-1.479l-.251-1.302a4.2 4.2 0 0 0-.604-1.505L93.119 56.858c-1.34 2.345-1.354 3.682-1.024 4.492",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "M94.418 60.354c.175.268.045.677-.293.915-.337.237-.751.214-.929-.054s-.045-.677.292-.914c.338-.238.754-.214.93.053M98.782 66.991c.175.268.045.677-.292.915-.338.237-.754.213-.93-.054-.175-.268-.044-.677.293-.914.337-.238.753-.216.929.053M76.907 29.724c-.651 2.02-1.92 3.844-3.75 5.134a9.6 9.6 0 0 1-2.212 1.164q.165.657.386 1.3a10.9 10.9 0 0 0 2.566-1.341c2.14-1.509 3.606-3.663 4.322-6.043a52 52 0 0 0-1.312-.214"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M71.747 30.511c-6.06 4.272-7.629 12.823-3.501 19.097l7.952 12.089c.925 1.406 2.775 1.77 4.132.812l17.034-12.005c1.358-.957 1.711-2.873.785-4.279l-7.953-12.089c-4.127-6.275-12.387-7.897-18.449-3.625m7.916 1.89-9.116 6.428a.49.49 0 0 1-.747-.24c-.418-1.139-.042-2.467.972-3.182l5.732-4.04a2.54 2.54 0 0 1 3.217.23.525.525 0 0 1-.058.804"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M72.058 30.98c-5.802 4.09-7.31 12.303-3.358 18.31l7.952 12.088c.754 1.146 2.267 1.443 3.374.663l17.032-12.005c1.107-.78 1.394-2.347.64-3.492l-7.952-12.09c-3.951-6.006-11.886-7.565-17.688-3.475m8.377 1.564-10.04 7.077a.535.535 0 0 1-.76-.15c-.98-1.49-.609-3.52.831-4.534l5.732-4.04c1.44-1.015 3.4-.63 4.383.86a.58.58 0 0 1-.146.787"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "m88.024 41.447-12.41 8.746A1.333 1.333 0 0 0 75.282 52l.935 1.422c1.236 1.878 3.71 2.365 5.525 1.085l7.914-5.578c1.816-1.28 2.285-3.84 1.05-5.718l-.936-1.422a1.23 1.23 0 0 0-1.745-.343"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m87.022 39.921-12.41 8.747a1.23 1.23 0 0 1-1.746-.343l-.936-1.422c-1.236-1.879-.766-4.44 1.049-5.718l7.915-5.58c1.815-1.279 4.288-.792 5.524 1.086l.935 1.421c.39.595.243 1.405-.331 1.809"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#97A6B7",
    d: "M73.156 34.857a9.45 9.45 0 0 1-8.556 1.228q-.148.664-.303 1.327a10.72 10.72 0 0 0 9.6-1.432q.398-.28.764-.591-.391-.546-.788-1.089-.344.292-.717.557"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.723,
    x2: 72.104,
    y1: 44.485,
    y2: 44.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16.623,
    x2: 72.18,
    y1: 44.461,
    y2: 44.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 31.265,
    x2: 59.966,
    y1: 9.338,
    y2: 9.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 12.157,
    x2: 9.693,
    y1: 97.356,
    y2: 94.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 56.148,
    x2: 45.297,
    y1: 113.794,
    y2: 103.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 54.536,
    x2: 43.849,
    y1: 104.145,
    y2: 104.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 37.761,
    x2: 48.642,
    y1: 91.038,
    y2: 112.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B7C0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 19.531,
    x2: 10.784,
    y1: 98.654,
    y2: 98.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 5.534,
    x2: 14.861,
    y1: 87.418,
    y2: 105.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B7C0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 101.577,
    x2: 88.559,
    y1: 102.789,
    y2: 102.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 81.755,
    x2: 94.11,
    y1: 88.271,
    y2: 112.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 93.155,
    x2: 86.432,
    y1: 103.022,
    y2: 103.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 85.996,
    x2: 179.623,
    y1: 130.879,
    y2: 248.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 78.845,
    x2: 84.807,
    y1: 93.06,
    y2: 126.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B7C0CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 96.322,
    x2: 74.857,
    y1: 94.532,
    y2: 94.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 94.771,
    x2: 76.928,
    y1: 97.101,
    y2: 97.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 36.84,
    x2: 22.14,
    y1: 96.824,
    y2: 90.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 34.637,
    x2: 6.472,
    y1: 110.822,
    y2: 83.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 85.561,
    x2: 38.248,
    y1: 75.848,
    y2: 75.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 29.74,
    x2: 14.073,
    y1: 75.448,
    y2: 75.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 40.908,
    x2: 25.348,
    y1: 76.819,
    y2: 76.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 75.224,
    x2: 52.706,
    y1: 91.71,
    y2: 69.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 40.556,
    x2: 39.814,
    y1: 83.749,
    y2: 83.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 32.816,
    x2: 26.154,
    y1: 84.413,
    y2: 77.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 24.344,
    x2: 17.694,
    y1: 80.14,
    y2: 73.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 37.959,
    x2: 28.655,
    y1: 83.801,
    y2: 74.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 105.407,
    x2: 92.875,
    y1: 26.028,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 89.313,
    x2: 95.59,
    y1: 52.105,
    y2: 19.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9085"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 93.781,
    x2: 98.265,
    y1: 48.178,
    y2: 25.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 77.129,
    x2: 80.722,
    y1: 74.789,
    y2: 53.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 80.613,
    x2: 84.395,
    y1: 25.062,
    y2: 69.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD626B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FD626C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FD626B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#FE7D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FD606E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FD636B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD626B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 101.524,
    x2: 92.543,
    y1: 69.249,
    y2: 58.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 101.952,
    x2: 92.971,
    y1: 68.529,
    y2: 58.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOrder);
export default __webpack_public_path__ + "static/media/closeOrder.5d8df65ab8dcff967aa3466629fbcc03.svg";
export { ForwardRef as ReactComponent };